// extracted by mini-css-extract-plugin
export default {"container":"styles_container__t5BtA","contentWrapper":"styles_contentWrapper__DoYM6","cardContainer":"styles_cardContainer__wTowA","couple":"styles_couple__9-iWo"};